const { ccclass, property } = cc._decorator;

@ccclass
export default class ComeInOutItem extends cc.Component {

    @property(cc.Label)
    lbText: cc.Label = null;

    // LIFE-CYCLE CALLBACKS:

    onLoad() {

    }

    start() {

    }

     setText(text:string){
         this.lbText.string = text;
     }

    // update (dt) {}
}
